module.exports = __webpack_public_path__ + "img/avatiach_yes.134af5ec.png";